import modal from 'helpers/modal';
import template from '../templates/PayrollItemSelectionModal.html';
import ItemButtonView from './PayrollItemSelectionButton.js';
import Address from 'newModels/address.js';
import Vehicle from 'newModels/vehicle.js';
import Furnishing from 'newModels/furnishing.js';
const AdditionalInfoClasses = {Address, Vehicle, Furnishing};
const AdditionalInfoModals = {
    Address: require('commons/views/AddressModal'),
    Vehicle: require('commons/views/VehicleModal'),
    Furnishing: require('commons/views/FurnishingModal')
};

module.exports = Backbone.View.extend({
    tagName:   'div',
    itemViews: [],

    events: {
        'hide.bs.modal':                    'render',
        'show.bs.modal':                    'render',
        'hidden.bs.modal':                  'onHidden',
        'shown.bs.modal':                   'onShown',

        'click .js-category-button':        'toggleCategory',
        'click .js-back-button':            'showCategoryNav',
        'click .js-add-selected-button':    'select',
        'click .js-clear-selection-button': 'clearCategorySelection',

        'afterChange .js-slider':           'fixOpacity'
    },

    initialize: function(options) {
        this.additionalForms = {};
        this.additionalInfo =  {};

        this.options = _.defaults(options || {}, {type: 'addition'});

        if (this.collection) {
            this.bindHandlers();
        }

        this.render();
    },

    bindHandlers: function() {
        this.collection.on('select unselect', this.updateSelectCounters, this);
        this.collection.on('select', this.showAdditionalForm, this);
    },

    setCollection: function(collection) {
        this.collection = collection;

        this.render();
        this.bindHandlers();
    },

    render: function() {
        this.$el.addClass('modal inmodal').html(template({
            title: this.options.title || 'Add Payroll Item',
            text: this.options.text || false,
            collection: this.collection || null
        }));
        this.$el.attr('data-backdrop', 'static');
        this.$el.attr('data-keyboard', 'false');

        this.$('.js-slider').css({opacity: 0}).slick({
            slidesToShow: 1,
            arrows:       false,
            draggable:    false,
            infinite:     false,
            swipe:        false,
            touchMove:    false
        }).slick('slickGoTo', 0);

        _.each(this.collection.getSelected(), function(model) {
            this.updateSelectCounters(model);
        }.bind(this));
    },

    fixOpacity: function() {
        this.$('.js-slider').css({opacity: ''});
    },

    updateSelectCounters: function(model) {
        var category = model.get('category');
        var $counter = this.$(
            '[data-toggle-category=' + category +
                '].js-category-button .counter'
        );
        var $categoryButton = $counter.closest('.js-category-button');

        var $clearButton = $categoryButton.find('.js-clear-selection-button');

        var count = this.collection.getSelectedByCategory(category).length;
        var total = this.collection.getByCategory(category).length;

        $counter.toggleClass('hidden', (count <= 0));
        $clearButton.toggleClass('hidden', (count <= 0));
        $categoryButton.toggleClass('selected', (count > 0));

        $counter.find('.count').text(count);
        $counter.find('.total').text(total);
    },

    showCategoryNav: function(ev) {
        ev.preventDefault();
        this.$('.js-slider').slick('slickGoTo', 0);
    },

    showAdditionalForm: function(model) {
        var formClass = model.get('additionalInfoClass');

        if (!formClass) {
            return;
        }

        if (!_.isFunction(AdditionalInfoModals[formClass])) {
            modal.showError('An application error ocurred. Contact support.');
            return;
        }

        if (!this.$el.hasClass('in')) {
            /* don't act if the modal is in a hidden state */
            return;
        }

        if (!_.isObject(this.additionalForms[formClass])) {
            this.additionalForms[formClass] =
                new AdditionalInfoModals[formClass]({
                    actOnSave:     false,
                    actOnCancel:   false,
                    actOnDestroy:  false,
                    templateExtra: {
                        title: 'Additional Information for \'' +
                            model.get('name') + '\''
                    }
                });

            this.additionalForms[formClass].on('save', function(additional) {
                this.additionalInfo[model.id] = additional.toJSON({
                    asAdditionalInformation: true
                });
            }, this);
            this.additionalForms[formClass].on('cancel', function() {
                this.additionalInfo[model.id] = undefined;
            }, this);
        }

        const additionalInfoModel = new AdditionalInfoClasses[formClass]();
        this.additionalForms[formClass].setModel(additionalInfoModel);
        this.additionalForms[formClass].$el.attr('data-backdrop', 'static');
        this.additionalForms[formClass].$el.attr('data-keyboard', 'false');
        this.additionalForms[formClass].show();
    },

    toggleCategory: function(ev) {
        var $button = this.$(ev.currentTarget);
        var category = parseInt($button.data('toggleCategory'), 10);
        var categoryModels = this.collection.getByCategory(category);

        ev.preventDefault();

        _.each(this.itemViews, function(view) { view.remove(); });
        this.itemViews = [];

        _.each(categoryModels, this.renderItem.bind(this));

        this.$('.js-slider').slick('slickGoTo', 1);
        this.$('.js-category-name').text(
            category === 0 ? 'Remuneration' :
            category === 1 ? 'Allowances' :
            category === 2 ? 'Benefits-in-Kind' :
            category === 3 ? 'Deductions' :
            category === 4 ? 'Other Perquisites' : ''
        );
    },

    renderItem: function(model) {
        var itemView = new ItemButtonView({
            model: model,
            additionalInfo: this.additionalInfo[model.id]
        });

        this.itemViews.push(itemView);
        this.$('.items').append(itemView.$el);
    },

    removeItemView: function(model) {
        this.itemViews = _.reject(this.itemViews, function(view) {
            return (view.model === model);
        });
    },

    select: function(ev) {
        ev.preventDefault();

        var id = this.$('[name=id]').val();
        var model = this.collection.get(id);

        if (model) {
            this.trigger('select', [model], this.additionalInfo);
        }

        this.trigger(
            'select', this.collection.getSelected(), this.additionalInfo
        );
        this.hide();
    },

    clearCategorySelection: function(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var $button = this.$(ev.currentTarget);

        this.collection.clearSelectionForCategory($button.data('category'));
    },

    onHidden: function() {
        this.trigger('hide');
        this.$('.modal-body').addClass('hidden');
    },

    onShown: function() {
        this.trigger('show');

        if (this.keepState === true) {
            this.keepState = false;
            return;
        }

        this.collection.clearSelection();
    },

    hide: function(options) {
        options = _.defaults(options || {}, {keepState: false});

        if (options.keepState === true) {
            this.keepState = true;
        }

        this.$el.modal('hide');
    },

    show: function() {
        this.$el.modal('show');
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/PayrollItemSelectionModal.js